import './style.less';
// import template from 'directives/fitHeight/template.html';

export default function($timeout) {
  'ngInject';
  return {
    restrict: 'A',
    link: (scope, element) => {
      // $timeout(() => {
      //   console.log('element ---------------------------------', element);
      //   console.log('Height:', element[0].offsetHeight);
      //   console.log('Leflt:', element[0].offsetLeft);
      //   console.log('Top:', element[0].offsetTop);
      //   console.log('Width', element[0].offsetWidth);
      //   console.log('parent ----------------------------------');
      //   console.log('Height:', element[0].offsetParent.clientHeight);
      //   console.log('Leflt:', element[0].offsetParent.clientLeft);
      //   console.log('Top:', element[0].offsetParent.clientTop);
      //   console.log('Width', element[0].offsetParent.clientWidth);
      //   console.log('---------------------------TOTALS--------------------------------');
      //   const containerEdgelocation = element[0].offsetParent.clientWidth + element[0].offsetParent.clientLeft;
      //   const childEdgeLcoaiton = element[0].offsetLeft + element[0].offsetWidth;
      //   console.log('containerEdgelocation', containerEdgelocation);
      //   console.log('childEdgeLcoaiton', childEdgeLcoaiton);
      //   console.log('total', containerEdgelocation - childEdgeLcoaiton);
      //   console.log('END ______________________________________________________');
      //   element.addClass('dropdown-left');
      // }, 0);
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/directives/dropdownPosition/index.js